import { render, staticRenderFns } from "./skyband.vue?vue&type=template&id=357544a0"
import script from "./skyband.vue?vue&type=script&lang=js"
export * from "./skyband.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports